import styled from 'styled-components';
import { colours } from 'themes/default';

import { extendedServiceStopStatuses } from 'types/timetableServices';

const statusColours = {
  [extendedServiceStopStatuses.CANCELLED]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.EXPECTED]: colours.Messaging.WarningOrange,
  [extendedServiceStopStatuses.ARRIVED_LATE]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.DEPARTED_LATE]: colours.Messaging.ErrorRed
};

const stationStatusTextDecoration = {
  [extendedServiceStopStatuses.CANCELLED]: 'line-through'
};

const timeStatusTextDecoration = {
  [extendedServiceStopStatuses.CANCELLED]: 'line-through',
  [extendedServiceStopStatuses.EXPECTED]: 'line-through',
  [extendedServiceStopStatuses.ARRIVED_LATE]: 'line-through',
  [extendedServiceStopStatuses.ARRIVED_EXPECTED_LATE]: 'line-through',
  [extendedServiceStopStatuses.DEPARTED_LATE]: 'line-through',
  [extendedServiceStopStatuses.DEPARTED_EXPECTED_LATE]: 'line-through'
};

const stationIconSize = '.75rem';
const lineWidth = '1px';
const timeCellWidth = '4rem';

export const Timetable = styled.div`
  box-sizing: border-box;
  display: table;

  * {
    box-sizing: border-box;
  }
`;

export const TimetableItem = styled.div`
  align-items: center;
  display: table-row;
  padding: 0.5rem 0;
  position: relative;

  > :first-child {
    padding-right: calc(${stationIconSize} * 2);

    &::before {
      background: ${({ dark }) => (dark ? colours.Greyscale.White : colours.Greyscale.Black)};
      content: '';
      display: block;
      height: 100%;
      position: absolute;
      right: ${stationIconSize};
      top: 0;
      width: ${lineWidth};
    }

    &::after {
      background: ${colours.Greyscale.White};
      border: ${lineWidth} solid ${({ dark }) => (dark ? colours.Greyscale.White : colours.Greyscale.Black)};
      border-radius: 999em;
      box-sizing: border-box;
      content: '';
      display: block;
      height: ${stationIconSize};
      position: absolute;
      right: calc(${stationIconSize} * 0.5);
      top: calc(50% - ${stationIconSize} * 0.5);
      width: ${stationIconSize};
    }
  }

  &:first-child {
    > :first-child {
      &::before {
        top: 50%;
      }

      &::after {
        top: calc(50% - ${stationIconSize} * 0.5 - 1px);
      }
    }
  }

  &:last-child {
    > :first-child {
      &::before {
        height: 50%;
      }
    }
  }
`;

export const TimetableTime = styled.div`
  display: table-cell;
  min-width: ${timeCellWidth};
  padding: 0.5rem 0;
  position: relative;
  vertical-align: middle;
`;

export const TimetableDetailData = styled.span`
  color: ${({ status }) => statusColours[status] || 'inherit'};
  display: block;
  text-decoration: ${({ status }) => timeStatusTextDecoration[status] || 'none'};

  &::after {
    content: ' ';
  }
`;

export const TimetableDetailDataBoardingOnly = styled.span`
  color: ${({ status }) => statusColours[status] || 'inherit'};
  display: block;

  &::after {
    content: ' ';
  }
`;

export const TimetableItemDetails = styled.div`
  display: table-cell;
  padding: 0.5rem 0;
  vertical-align: middle;
`;

export const TimetableStationName = styled.div`
  color: ${({ status }) => statusColours[status] || 'inherit'};
  text-decoration: ${({ status }) => stationStatusTextDecoration[status] || 'none'};
`;

export const TimetableDetailTime = styled.div`
  color: ${({ status }) => statusColours[status] || 'inherit'};
  font-size: 0.8em;
`;
